import BaseComponent from '../../../general/js/base-component';
import template from '../html/template.hbs';
import intersectionHelper from '../../../general/js/intersection-helper';
import TweenLite from 'gsap/TweenLite';

export default class AuctionResultNumberComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.number = parseInt(this.element.dataset.number);
        if (isNaN(this.number)) {
            throw new Error('data-number is not a number');
        }

        intersectionHelper.enterViewportOnce(this.element, this.init.bind(this), {
            threshold: 1.0
        });
    }

    init() {
        let number = {value: 0};

        TweenLite.to(number, 2.5, {
            value: this.number,
            ease: Power4.easeOut,
            onUpdate: () => {
                this.render(number);
            }
        });
    }

    render(number) {
        let value = Math.ceil(number.value);
        let numbers = this.getSplittedValue(value);
        this.element.innerHTML = template({numbers});
    }

    getSplittedValue(value) {

        let digits = this.getPreparedDigitsArray(value);
        let chunkSize = 3;
        let arrayLength = digits.length;

        let chunks = [];

        for (let index = arrayLength; index > 0; index -= chunkSize) {
            let start = Math.max(index - chunkSize, 0);
            let chunk = digits.slice(start, index);
            chunks.unshift(chunk);
        }

        return chunks;
    }

    getPreparedDigitsArray(value) {
        let targetStringLength = (this.number + '').length;
        let valueString = value + '';

        let digits = valueString.split('');

        if (digits.length < targetStringLength) {
            let leftDigits = targetStringLength - digits.length;
            let filledArray = [];
            for (let i = 0; i < leftDigits; i++) {
                filledArray.push('')
            }
            digits.unshift(filledArray);
        }

        return digits;
    }
}



// WEBPACK FOOTER //
// ./app/components/auction-results/js/auction-result-number.component.js